import { PurchaseConstant } from '../constants';
import { RequestAction } from '.';

export const createPurchase = data =>
  RequestAction.request(PurchaseConstant.CREATE_PURCHASE, {
    data,
    method: 'post',
    url: `/api/purchase`,
  });

export const deletePurchase = id =>
  RequestAction.request(PurchaseConstant.DELETE_PURCHASE, {
    method: 'delete',
    url: `/api/purchase/${id}`,
  });

export const editPurchase = (id, data) =>
  RequestAction.request(PurchaseConstant.EDIT_PURCHASE, {
    data,
    method: 'put',
    url: `/api/purchase/${id}`,
  });

export const getPurchase = id =>
  RequestAction.request(PurchaseConstant.GET_PURCHASE, {
    url: `/api/purchase/${id}`,
  });

export const getPurchases = params =>
  RequestAction.request(PurchaseConstant.GET_PURCHASES, {
    params,
    url: '/api/purchase',
  }, false);

export const restorePurchase = id =>
  RequestAction.request(PurchaseConstant.RESTORE_PURCHASE, {
    method: 'put',
    url: `/api/purchase/${id}/restore`,
  });

export const setPurchase = payload => ({
  payload,
  type: PurchaseConstant.SET_PURCHASE,
});

export const setPurchases = payload => ({
  payload,
  type: PurchaseConstant.SET_PURCHASES,
});
